var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"divider__line",class:{ 'divider__line--spacing-top': _vm.spacingTop,
'divider__line--spacing-top-large': _vm.spacingTopLarge,
'divider__line--spacing-bottom': _vm.spacingBottom,
'divider__line--spacing-bottom-large': _vm.spacingBottomLarge }})
}
var staticRenderFns = []

export { render, staticRenderFns }